<div class="heavier">{{ $value() | currency: 'USD' : 'symbol' }}</div>
